import posthog, { type ToolbarParams } from "posthog-js";
import type { AuthenticationDetails, InitOptions } from "./types";

const toolbarJSON = new URLSearchParams(window.location.hash.substring(1)).get("__posthog");

if (toolbarJSON) {
  posthog.loadToolbar(JSON.parse(toolbarJSON) as ToolbarParams);
}

let resolvePostHogIdentified: () => void;
export const postHogIdentified = new Promise<void>((resolve) => {
  resolvePostHogIdentified = resolve;
});

export const posthogAttachAuth = (details: AuthenticationDetails & { groups: string[] }) => {
  const env = details.env;

  // Reset if different user logs in (common for QA switching accounts)
  const currentDistinctId = posthog.get_distinct_id();
  if (currentDistinctId && currentDistinctId !== details.user.id) {
    posthog.reset();
  }

  // Identify user (no personal data - GDPR)
  posthog.identify(details.user.id, {
    user_id: details.user.id,
    org_id: details.org.id,
    org_name: details.org.name,
    org_alias: details.org.alias,
    env,
  });
  resolvePostHogIdentified();

  // Org group
  posthog.group("org", details.org.id?.toString() ?? "", {
    env,
    alias: details.org.alias,
    name: details.org.name,
    description: details.org.description,
    version: details.version,
    tag: details.tag,
    branch: details.branch,
  });

  // User groups
  for (const group of details.groups) {
    posthog.group("userGroup", group, { env });
  }
};

export const posthogInit = (p: InitOptions) => {
  posthog.init("phc_5VQrxO6QX946p5WIhQcFj6QJK5fsVbXn8iOsVsbhCh2", {
    autocapture: p.isProduction,
    capture_pageview: p.isProduction,
    capture_pageleave: p.isProduction,
    api_host: `${window.location.origin}/ingest`,
    ui_host: "https://eu.posthog.com",
    person_profiles: "identified_only",
    disable_session_recording: !p.isProduction,
    advanced_disable_feature_flags: true,
    loaded: (posthog) => {
      posthog.register({ env: p.env, version: p.version, tag: p.tag, branch: p.branch });
      posthog.setPersonProperties({ version: p.version, tag: p.tag, branch: p.branch });
      // Send one-time event to register the env property in PostHog
      posthog.capture("posthog_initialized", { env: p.env });
    },
  });
};
